import { useLocation } from "react-router-dom";
import { Button, Card, CardFooter, Container } from "reactstrap";
import Header from "../../components/globals/Header";
import { calculateDistanceKm, formatDurationInHoursMinutes, useGoBack } from "../../utils";
import { IoArrowBackSharp } from "react-icons/io5";
import { useEffect, useState } from "react";
import UserLocationSelect from "../../components/inputs/UserLocationSelect";
import { FaLocationDot } from "react-icons/fa6";
import { FaCar } from "react-icons/fa6";
import { GiCycling } from "react-icons/gi";
import { FaWalking } from "react-icons/fa";
import DirectionMap from "../../components/navigators/DirectionMap";
import { useDeviceLocation } from "../../hooks/utilityHooks";


const transferTypes = [
  { title: "car", icon: <FaCar size={30} />, estimatedTime: "9h 24m" },
  { title: "cycle", icon: <GiCycling size={30} />, estimatedTime: "12h 9m" },
  { title: "walk", icon: <FaWalking size={30} />, estimatedTime: "17h 10m" },
];

const Directions = () => {
  const { state } = useLocation();
  const {location}=useDeviceLocation(true);
  const goBack = useGoBack();
  console.log("Getting directions of ....",state);
  const [directionModeActive, setDirectionModeActive] = useState(false);
  const [transferType, setTransferType] = useState("");
  const [transferOptions,setTransferOptions]=useState(transferTypes);


  const calculateTransferOptions = () => {
    if (!state?.geo?.coordinates || !location?.latitude) return;

    const [destLon, destLat] = state.geo.coordinates;
    const { latitude: userLat, longitude: userLon } = location;
    const distanceKm = calculateDistanceKm([userLat, userLon], [destLat, destLon]);

    const speeds = {
      walk: 5,
      cycle: 15,
      car: 80,
    };

    const results = transferTypes.map((t) => {
      const speed = speeds[t.title];
      const hours = distanceKm / speed;
      return {
        ...t,
        estimatedTime: formatDurationInHoursMinutes(hours),
      };
    });

    // Filter out impractical options (optional)
    const filtered = results.filter((r) => {
      if (r.title === "walk" && distanceKm > 30) return false;
      if (r.title === "cycle" && distanceKm > 200) return false;
      return true;
    });

    setTransferOptions(filtered);
  };

  useEffect(()=>{
    calculateTransferOptions();
  },[state,location])



  return (
    <div>
      <Container fluid>
        <Header title={"Direction"} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-2rem align-items-center full-width"
        >
          <Button
            onClick={goBack}
            className="bg-transparent border-none color-primary-blue"
          >
            <IoArrowBackSharp size={24} />
          </Button>
          <h5 className="f-7 color-primary-blue m-0">
            {state?.name ?? "Royale Cuisine"}
          </h5>
        </div>
        <Card className="border-none figma-card-radius direction-div">
          {!directionModeActive && (
            <div className="mb-3">
              <>
                <div className="mx-md-5 mx-3 my-1_5rem">
                  <UserLocationSelect />
                  <Card className="location-card">
                    <FaLocationDot size={25} color="rgba(255, 80, 80, 1)" />
                    <h6 className="m-0 f-4 color-half-black-2">
                      {state?.name} : {state?.location?.streetAddress}
                    </h6>
                  </Card>
                </div>
                <div className="d-flex align-items-center gap-lg-5 gap-3 flex-wrap justify-content-center">
                  {transferOptions?.map((item, at) => (
                    <Button
                      key={at}
                      onClick={() => setTransferType(item?.title)}
                      className={` transfer-type  ${
                        item?.title === transferType ? "active" : ""
                      } `}
                    >
                      <div className="icon mb-3">{item?.icon}</div>
                      <span className="d-block">{item?.estimatedTime}</span>
                    </Button>
                  ))}
                </div>
              </>
            </div>
          )}
          <CardFooter className="p-0 border-none">
            <DirectionMap
              onModeChange={(currentMode, modes) => {
                if (currentMode === modes?.STARTED)
                  setDirectionModeActive(true);
                else setDirectionModeActive(false);
              }}
              placeData={state}
            />
          </CardFooter>
        </Card>
      </Container>
    </div>
  );
};

export default Directions;
